<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Price Levels</div>
	</div>
	<p-divider></p-divider>

	<div class="">
		<p-table
			#dt
			styleClass="p-datatable-responsive-demo"
			[value]="priceLevels"
			[loading]="!priceLevels"
			[globalFilterFields]="app.keys(priceLevels)"
			[scrollable]="true"
			[rows]="100"
			scrollHeight="700px"
			[virtualScroll]="true"
			[virtualRowHeight]="40"
		>
			<ng-template pTemplate="caption">
				<div class="table-header d-flex">
					<div class="flex-grow-1">
						<span class="p-float-label p-input-icon-left m-2 w-100">
							<i class="pi pi-search"></i>
							<input
								pInputText
								class="w-100"
								id="globalSearch"
								name="globalSearch"
								style="width: 100%"
								type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
							/>
							<label for="globalSearch">Search...</label>
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th>Name</th>
					<th>Price 1</th>
					<th>Price 2</th>
					<th>Price 3</th>
					<th>Price 4</th>
					<th>Price 5</th>
					<th>Price 6</th>
				</tr>
			</ng-template>
			<ng-template let-rec pTemplate="body">
				<tr (click)="priceLevelSelected = rec">
					<td>{{ rec.name }}</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName1 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName1 }}
						</div>
					</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName2 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName2 }}
						</div>
					</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName3 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName3 }}
						</div>
					</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName4 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName4 }}
						</div>
					</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName5 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName5 }}
						</div>
					</td>
					<td class="d-flex flex-column">
						<div>
							{{ rec.priceName6 }}
						</div>
						<div class="text-italics">
							{{ rec.priceDisplayName6 }}
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<p-dialog *ngIf="priceLevelSelected" [(visible)]="priceLevelSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<p-header>
		<div class="h3">Edit {{ priceLevelSelected.name }}</div>
	</p-header>

	<div class="d-flex flex-column">
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle" class="mt-1"> Price 1 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName1 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price1" id="price1" [(ngModel)]="priceLevelSelected.priceDisplayName1" class="w-100" />
					<label for="price1">Price 1 Display Name</label>
				</span>
			</div>
		</div>
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle"> Price 2 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName2 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price2" id="price2" [(ngModel)]="priceLevelSelected.priceDisplayName2" class="w-100" />
					<label for="price1">Price 2 Display Name</label>
				</span>
			</div>
		</div>
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle"> Price 3 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName3 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price3" id="price3" [(ngModel)]="priceLevelSelected.priceDisplayName3" class="w-100" />
					<label for="price1">Price 3 Display Name</label>
				</span>
			</div>
		</div>
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle"> Price 4 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName4 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price4" id="price4" [(ngModel)]="priceLevelSelected.priceDisplayName4" class="w-100" />
					<label for="price1">Price 4 Display Name</label>
				</span>
			</div>
		</div>
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle"> Price 5 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName5 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price5" id="price5" [(ngModel)]="priceLevelSelected.priceDisplayName5" class="w-100" />
					<label for="price1">Price 5 Display Name</label>
				</span>
			</div>
		</div>
		<div class="p-grid d-flex mt-3">
			<div class="col-2">
				<span style="vertical-align: middle"> Price 6 </span>
			</div>
			<div class="col-2 align-bottom">
				{{ priceLevelSelected.priceName6 }}
			</div>
			<div class="col-8">
				<span class="p-float-label w-100">
					<input pInputText type="text" name="price6" id="price6" [(ngModel)]="priceLevelSelected.priceDisplayName6" class="w-100" />
					<label for="price1">Price 6 Display Name</label>
				</span>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="priceLevelSelected = undefined"
			(onSaveChange)="priceLevelSave(priceLevelSelected); priceLevelSelected = undefined"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
